/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   constants.ts
 */

export const CONFIRM_EMAIL_CHANGE_SUCCESS = {
  message:
    'The email address associated with your account has been updated. You can use it to sign in from now on.',
} as const

export const CONFIRM_EMAIL_CHANGE_ERROR = {
  message: 'We could not update your email address.',
  actionText: 'Please contact support',
  action: () => {
    window.open('https://help.zumper.com/hc/en-us/requests/new', '_blank')
  },
} as const
